
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.35012',
  depVersions: {
  "documents-public-ui": "static-1.35012",
  "atom": "static-1.5270",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2692",
  "client-types": "static-1.489",
  "cssUtils": "static-1.846",
  "customer-data-filters-ui": "static-1.40537",
  "customer-data-objects": "static-1.7874",
  "customer-data-property-utils": "static-1.8290",
  "documents-lib": "static-1.35017",
  "emoji-mart": "static-3.4",
  "flux-actions": "static-1.354",
  "FormsCommonComponents": "static-1.86366",
  "FormUrlGenerator": "static-2.4917",
  "foundations-theming-specialty": "static-1.2349",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.5007",
  "highcharts": "static-8.107",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5787",
  "hs-test-utils": "static-1.8216",
  "hub-http": "static-1.6412",
  "hubspot-dlb": "static-2.1854",
  "HubStyle": "static-2.11976",
  "HubStyleTokens": "static-2.11669",
  "I18n": "static-7.1648",
  "icons": "static-2.667",
  "jasmine-immutable": "static-1.3215",
  "jasmine-runner": "static-1.6649",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7346",
  "lodash": "static-1.3",
  "PatternValidationJS": "static-1-add-latest-to-version-tag.2",
  "pdf-js": "static-2.49",
  "property-translator": "static-1.5588",
  "quartz": "static-1.7287",
  "react": "static-7.189",
  "react-dlb": "static-1.83",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.71",
  "react-rhumb": "static-1-aeastham-base-reporter-resolved-tracking.3",
  "react-select-plus": "static-1.108",
  "react-utils": "static-2.5475",
  "react-virtualized": "static-2.102",
  "reference-resolvers": "static-1.8371",
  "reference-resolvers-lite": "static-1.8291",
  "reporting-data": "static-1.68323",
  "reporting-reports": "static-1.68001",
  "reporting-snowflake": "static-1.56941",
  "reporting-testing-lib": "static-1.10256",
  "reporting-visualizations": "static-1.60399",
  "reselect": "static-3.8",
  "sales-content-partitioning": "static-1.9143",
  "sanitize": "static-1.4671",
  "sanitize-text": "static-1.8340",
  "SharedI18nStrings": "static-1.182",
  "SharedLegalStrings": "static-1.1938",
  "signup-constants": "static-1.19356",
  "signup-ui-url-generator": "static-2.8251",
  "StyleGuideUI": "static-3.491",
  "superstore": "static-1.4953",
  "tinymce": "static-6.5",
  "transmute": "static-2.85",
  "ui-addon-draggable": "static-3.4951",
  "ui-addon-form-validation": "static-1.11184",
  "ui-asset-management-lib": "static-1.11277",
  "ui-images": "static-2.1209",
  "UIComponents": "static-3.8615",
  "usage-tracker": "static-1.7545",
  "usage-tracker-container": "static-1.7535",
  "usage-tracker-core": "static-1.7395",
  "viral-links-lib": "static-1.7265",
  "webpack-env": "static-1.54",
  "data-fetching-client": "static-1.9852",
  "foundations-components": "static-1.8298",
  "immutable": "static-2.79",
  "isMobile": "static-1.7",
  "PortalIdParser": "static-2.404",
  "quartz-config": "static-1.1065",
  "quartz-core": "static-1.6506",
  "quick-fetch": "static-1.4052",
  "raven": "static-3.5925",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "rpc-client-utils": "static-1.4852",
  "ui-addon-i18n": "static-1.11341",
  "ui-addon-upgrades": "static-9.18243",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4132",
  "metrics-js": "static-1.9637",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3534",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3564",
  "quartz-webpack": "static-1.3511",
  "foundations-assets": "static-1.5069",
  "foundations-theming": "static-1.4633",
  "hub-http-shared-msw-handlers": "static-1.10431",
  "hubspotter-http": "static-1.4785",
  "sassPrefix": "static-1.160",
  "conversations-skeleton-state": "static-1.7441",
  "crm-message-bus": "static-1.43538",
  "customer-data-filters-ui-msw-helpers": "static-1.22972",
  "customer-data-objects-ui-components": "static-1.13226",
  "customer-data-reference-ui-components": "static-1.13370",
  "customer-data-ui-utilities": "static-1.10019",
  "events-data-lib": "static-1.432",
  "framework-builder-read-service-client": "static-1.4140",
  "framework-data-schema-quick-fetch": "static-1.6993",
  "framework-data-schema-resolvers": "static-1.7088",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3718",
  "inbound-db-properties-service-client": "static-1.3979",
  "multi-account-reference-resolvers": "static-1.1177",
  "onboarding-tours": "static-1.16959",
  "reporting-datasets-permissions-lib": "static-1.14238",
  "stylex": "static-1.37",
  "trellis-assets": "static-1.2317",
  "trellis-components": "static-1.2336",
  "trellis-theming": "static-1.1142",
  "ui-addon-teams": "static-1.21791",
  "quartz-auth": "static-1.962",
  "ui-business-units-lib": "static-1.9273",
  "usage-tracker-session-replay": "static-1.5231",
  "ai-components-ui-library": "static-1.9447",
  "ContentUtils": "static-1.68931",
  "customer-data-properties": "static-1.52240",
  "forms-ai-lib": "static-1.4613",
  "forms-utils-lib": "static-1.12931",
  "foundations-components-test-utils": "static-1.5781",
  "react-dnd-compat": "static-1.4809",
  "react-tinymce": "static-1.55760",
  "tinymce-config": "static-2.54886",
  "ui-gdpr-components": "static-1.10544",
  "underscore": "static-1.8",
  "foundations-theming-base": "static-1.3618",
  "HeadJS": "static-2.779",
  "framer-motion": "static-1.75",
  "hs-test-utils-bend-plugin": "static-1.3327",
  "msw": "static-1.39",
  "testing-library": "static-1.155",
  "hs-locale-management": "static-1.215",
  "ui-fonts": "static-1.931",
  "i18n-data": "static-1.225",
  "moment-timezone": "static-5.86",
  "jasmine": "static-4.4517",
  "csstype": "static-1.50",
  "quartz-head": "static-1.952",
  "web-vitals": "static-1.9",
  "batch-promise": "static-1.1738",
  "external-options-client-types": "static-1.4260",
  "fast-json-stable-stringify": "static-1.4",
  "quartz-i18n": "static-1.962",
  "frontend-preferences-client": "static-1.8121",
  "graphql": "static-1.85",
  "persist-promise": "static-1.3895",
  "reporting-client-types": "static-1.2617",
  "apollo-stack-hubspot": "static-3.89",
  "growth-payments-core": "static-1.25951",
  "hubspot-apollo-client": "static-1.5071",
  "foundations-components-legacy": "static-1.1323",
  "quartz-routing": "static-1.717",
  "hs-story-utils": "static-1.9620",
  "react-flip-move": "static-1.74",
  "nested-table": "static-1.431",
  "timezone-utils": "static-2.5438",
  "seat-types-lib": "static-1.447",
  "react-create-root-preference": "static-1.48",
  "bend-plugin-foundations-components": "static-1.4567",
  "floating-ui": "static-1.60",
  "react-aria": "static-1.69",
  "tanstack-table": "static-1.58",
  "dispatcher": "static-1.140",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.856",
  "mobile-manifest-mixins": "static-1.553",
  "module-federation": "static-1.29",
  "quartz-test": "static-1.962",
  "quartz-tracking": "static-1.666",
  "bend-plugin-chirp-manifest": "static-1.262",
  "chirp-fetch": "static-1.2081",
  "merchandise-lib": "static-1.269",
  "purchase-motions-components": "static-1.6197",
  "salesImages": "static-1.529",
  "ts-schema": "static-1.4214",
  "bender-build-tools": "static-1.3316",
  "bend-plugin-foundations-theming": "static-1.3116",
  "restore-request-side-panel-lib": "static-1.1392",
  "react-immutable-render-mixin": "static-1.9",
  "hs-resources": "static-1.373",
  "pulse": "static-1.810",
  "conditional-properties-service-client": "static-1.3931",
  "crm-pipelines-api-client-types": "static-1.4272",
  "fdsr-migration-layer": "static-1.207",
  "multi-currency-client-types": "static-1.3825",
  "getting-started-shared-tasks": "static-1.18983",
  "growth-data-modal": "static-1.5741",
  "growth-onboarding-confetti": "static-1.3255",
  "growth-onboarding-next-action-utils": "static-1.2484",
  "navigation-components": "static-1.18556",
  "onboarding-tours-client": "static-1.5173",
  "onboarding-tours-utils": "static-1.1025",
  "ui-shepherd-react": "static-3.10456",
  "ui-shepherd-tracker": "static-1.7837",
  "ui-universal-auth": "static-1.9208",
  "user-context": "static-1.5305",
  "base-ui": "static-1.17",
  "react-day-picker": "static-1.6",
  "tanstack-virtual": "static-1.33",
  "hubspotter-http-shared-msw-handlers": "static-1.10429",
  "magpie-lib": "static-1.5687",
  "navigation-messaging": "static-1.7883",
  "amplitude-session-replay-browser": "static-1.60",
  "chatspot-core": "static-1.22293",
  "copilot-toolkit": "static-1.11631",
  "cms-field-types": "static-1.5009",
  "content-icons-ui": "static-1.2282",
  "integrations-lib": "static-1.16767",
  "calling-global-api": "static-1.65166",
  "calling-internal-common": "static-1.31508",
  "calling-lifecycle-internal": "static-1.66548",
  "calling-lifecycle-messages": "static-1.58842",
  "commerce-products-lib": "static-1.10273",
  "crm-links": "static-1.6509",
  "customer-data-properties-shared-msw-handlers": "static-1.9758",
  "file-manager-components": "static-1.24190",
  "formula-editor": "static-1.14594",
  "google-libphonenumber": "static-1.41",
  "inbounddb-objects-service-types": "static-1.4350",
  "meetings-icalendar-utils-lib": "static-1.825",
  "object-builder-ui-client": "static-1.49381",
  "pipeline-validation-client-types": "static-1.4100",
  "property-value-citations": "static-1.2854",
  "smart-property-lib": "static-1.8081",
  "tiered-pricing": "static-1.1756",
  "topics-actions-lib": "static-1.346",
  "ui-addon-iframeable": "static-1.9270",
  "zustand": "static-1.79",
  "final-form": "static-1.73",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.20160",
  "tinymce-themes": "static-1.56856",
  "data-token-picker": "static-1.16740",
  "hub-http-contrib": "static-1.3235",
  "interframe": "static-3.4949",
  "tinymce-data": "static-1.40971",
  "tinymce-plugins": "static-1.58000",
  "ui-addon-sales-email": "static-1.5406",
  "onboarding-scopes": "static-1.6653",
  "ui-addon-opt": "static-4.8555",
  "apollo-link-hub-http": "static-2.4847",
  "hubspot-apollo-cache": "static-1.530",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.368",
  "purchase-motions-api": "static-1.6200",
  "event-emitter": "static-1.1144",
  "bend-plugin-pulse": "static-1.313",
  "fast-json-patch": "static-1.66",
  "onboarding-data-sync-lib": "static-1.2299",
  "growth-onboarding-next-action-components": "static-1.2512",
  "user-context-client": "static-1.4745",
  "idb-keyval": "static-1.47",
  "magpie-types": "static-1.5147",
  "nest": "static-1.430",
  "reactive-lib": "static-1.916",
  "simple-logging-lib": "static-1.3243",
  "unified-auth-core-lib": "static-1.1004",
  "getting-started-shared-tasks-store": "static-1.18101",
  "markdown-it": "static-1.6",
  "breeze-engine-lib": "static-1.1408",
  "integrations-error-boundary-lib": "static-1.14182",
  "integrations-tracking-lib": "static-1.5801",
  "native-integrations-shared-strings": "static-1.7972",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10559",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.722",
  "calling-error-reporting": "static-1.31515",
  "shared-worker-versioning": "static-1.11232",
  "calling-usage-tracker": "static-1.6734",
  "voice-sms-access-library": "static-1.1700",
  "customer-data-tracking": "static-1.7078",
  "commerce-permissions": "static-1.970",
  "products-iframe-lib": "static-1.8391",
  "products-ui-components-shared-msw-handlers": "static-1.10813",
  "location-customization-utils-lib": "static-1.9848",
  "apollo-dlb": "static-3.86",
  "immerable": "static-1.4341",
  "video-components-external": "static-1.11907",
  "video-data-lib": "static-1.35565",
  "bark-lib": "static-1.16686",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.98",
  "crm-properties-common-lib": "static-1.6081",
  "react-codemirror": "static-1.10832",
  "data-agent-kit": "static-1.497",
  "feedback-loader": "static-1.29650",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10514",
  "fsm": "static-1.3926",
  "policy-lib": "static-1.6981",
  "react-colorpicker": "static-2.10404",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10577",
  "FileManagerLib": "static-1.39830",
  "NamespacedHubStyle": "static-2.9184",
  "FileManagerCore": "static-1.39689",
  "content-assistance-lib": "static-1.8045",
  "layout-dnd-components": "static-1.12811",
  "layout-dnd-utils": "static-1.11786",
  "ui-addon-emoji-picker": "static-1.10079",
  "ui-brand-identity-lib": "static-1.15998",
  "InboxConnectUtils": "static-4.15342",
  "meetings-connect-utils-lib": "static-1.7800",
  "breeze-engine-core": "static-1.686",
  "ably": "static-2.2",
  "highlight.js": "static-1.82",
  "universal-page-editor-lib": "static-1.3205",
  "adobe-sign-auth-lib": "static-1.245",
  "ads-unified-auth-lib": "static-1.752",
  "google-sheets-integration-lib": "static-1.814",
  "microsoft-drive-integration-lib": "static-1.918",
  "surveymonkey-integration-lib": "static-1.260",
  "slack-ui-library": "static-1.10592",
  "calling-orchestration-schema": "static-1.36477",
  "sales-views-client-types": "static-1.4451",
  "crm-record-cards-service-types": "static-1.3718",
  "content-media-composition-data-lib": "static-1.12940",
  "content-media-compositions": "static-2.16947",
  "media-bridge-lib": "static-1.19258",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16137",
  "browser-eslint": "static-2.57",
  "trellis-story-utils": "static-1.4701",
  "storybook-react": "static-1.36",
  "audio-components": "static-1.6199",
  "FileManagerImages": "static-1.37341",
  "video-components": "static-1.13909",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.57",
  "urlinator": "static-1.4726",
  "video-embed": "static-1.36399",
  "ui-addon-video-player": "static-1.8900",
  "ui-coaching-tips": "static-1.29103",
  "ContentData": "static-1.69006",
  "layout-data-lib": "static-1.10111",
  "social-insights-client-types": "static-1.22581",
  "outpost": "static-1.4360",
  "growth-onboarding-feedback-components": "static-1.6775",
  "advanced-menus-core": "static-1.15440",
  "advanced-menus-lib": "static-1.12334",
  "ExportDialog": "static-6.10574",
  "ui-memberships-settings-lib": "static-1.34584",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15439",
  "simple-menus-lib": "static-1.16956"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.35012",
  "atom": "/atom/static-1.5270",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2692",
  "client-types": "/client-types/static-1.489",
  "cssUtils": "/cssUtils/static-1.846",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40537",
  "customer-data-objects": "/customer-data-objects/static-1.7874",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8290",
  "documents-lib": "/documents-lib/static-1.35017",
  "emoji-mart": "/emoji-mart/static-3.4",
  "flux-actions": "/flux-actions/static-1.354",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86366",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4917",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2349",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.5007",
  "highcharts": "/highcharts/static-8.107",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5787",
  "hs-test-utils": "/hs-test-utils/static-1.8216",
  "hub-http": "/hub-http/static-1.6412",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "HubStyle": "/HubStyle/static-2.11976",
  "HubStyleTokens": "/HubStyleTokens/static-2.11669",
  "I18n": "/I18n/static-7.1648",
  "icons": "/icons/static-2.667",
  "jasmine-immutable": "/jasmine-immutable/static-1.3215",
  "jasmine-runner": "/jasmine-runner/static-1.6649",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7346",
  "lodash": "/lodash/static-1.3",
  "PatternValidationJS": "/PatternValidationJS/static-1-add-latest-to-version-tag.2",
  "pdf-js": "/pdf-js/static-2.49",
  "property-translator": "/property-translator/static-1.5588",
  "quartz": "/quartz/static-1.7287",
  "react": "/react/static-7.189",
  "react-dlb": "/react-dlb/static-1.83",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.71",
  "react-rhumb": "/react-rhumb/static-1-aeastham-base-reporter-resolved-tracking.3",
  "react-select-plus": "/react-select-plus/static-1.108",
  "react-utils": "/react-utils/static-2.5475",
  "react-virtualized": "/react-virtualized/static-2.102",
  "reference-resolvers": "/reference-resolvers/static-1.8371",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8291",
  "reporting-data": "/reporting-data/static-1.68323",
  "reporting-reports": "/reporting-reports/static-1.68001",
  "reporting-snowflake": "/reporting-snowflake/static-1.56941",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.10256",
  "reporting-visualizations": "/reporting-visualizations/static-1.60399",
  "reselect": "/reselect/static-3.8",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.9143",
  "sanitize": "/sanitize/static-1.4671",
  "sanitize-text": "/sanitize-text/static-1.8340",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1938",
  "signup-constants": "/signup-constants/static-1.19356",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8251",
  "StyleGuideUI": "/StyleGuideUI/static-3.491",
  "superstore": "/superstore/static-1.4953",
  "tinymce": "/tinymce/static-6.5",
  "transmute": "/transmute/static-2.85",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4951",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11184",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11277",
  "ui-images": "/ui-images/static-2.1209",
  "UIComponents": "/UIComponents/static-3.8615",
  "usage-tracker": "/usage-tracker/static-1.7545",
  "usage-tracker-container": "/usage-tracker-container/static-1.7535",
  "usage-tracker-core": "/usage-tracker-core/static-1.7395",
  "viral-links-lib": "/viral-links-lib/static-1.7265",
  "webpack-env": "/webpack-env/static-1.54",
  "data-fetching-client": "/data-fetching-client/static-1.9852",
  "foundations-components": "/foundations-components/static-1.8298",
  "immutable": "/immutable/static-2.79",
  "isMobile": "/isMobile/static-1.7",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "quartz-config": "/quartz-config/static-1.1065",
  "quartz-core": "/quartz-core/static-1.6506",
  "quick-fetch": "/quick-fetch/static-1.4052",
  "raven": "/raven/static-3.5925",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "rpc-client-utils": "/rpc-client-utils/static-1.4852",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11341",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18243",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "metrics-js": "/metrics-js/static-1.9637",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3534",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3564",
  "quartz-webpack": "/quartz-webpack/static-1.3511",
  "foundations-assets": "/foundations-assets/static-1.5069",
  "foundations-theming": "/foundations-theming/static-1.4633",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10431",
  "hubspotter-http": "/hubspotter-http/static-1.4785",
  "sassPrefix": "/sassPrefix/static-1.160",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7441",
  "crm-message-bus": "/crm-message-bus/static-1.43538",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22972",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13226",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13370",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10019",
  "events-data-lib": "/events-data-lib/static-1.432",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4140",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6993",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7088",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3979",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1177",
  "onboarding-tours": "/onboarding-tours/static-1.16959",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14238",
  "stylex": "/stylex/static-1.37",
  "trellis-assets": "/trellis-assets/static-1.2317",
  "trellis-components": "/trellis-components/static-1.2336",
  "trellis-theming": "/trellis-theming/static-1.1142",
  "ui-addon-teams": "/ui-addon-teams/static-1.21791",
  "quartz-auth": "/quartz-auth/static-1.962",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9273",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5231",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9447",
  "ContentUtils": "/ContentUtils/static-1.68931",
  "customer-data-properties": "/customer-data-properties/static-1.52240",
  "forms-ai-lib": "/forms-ai-lib/static-1.4613",
  "forms-utils-lib": "/forms-utils-lib/static-1.12931",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5781",
  "react-dnd-compat": "/react-dnd-compat/static-1.4809",
  "react-tinymce": "/react-tinymce/static-1.55760",
  "tinymce-config": "/tinymce-config/static-2.54886",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10544",
  "underscore": "/underscore/static-1.8",
  "foundations-theming-base": "/foundations-theming-base/static-1.3618",
  "HeadJS": "/HeadJS/static-2.779",
  "framer-motion": "/framer-motion/static-1.75",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3327",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.155",
  "hs-locale-management": "/hs-locale-management/static-1.215",
  "ui-fonts": "/ui-fonts/static-1.931",
  "i18n-data": "/i18n-data/static-1.225",
  "moment-timezone": "/moment-timezone/static-5.86",
  "jasmine": "/jasmine/static-4.4517",
  "csstype": "/csstype/static-1.50",
  "quartz-head": "/quartz-head/static-1.952",
  "web-vitals": "/web-vitals/static-1.9",
  "batch-promise": "/batch-promise/static-1.1738",
  "external-options-client-types": "/external-options-client-types/static-1.4260",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "quartz-i18n": "/quartz-i18n/static-1.962",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8121",
  "graphql": "/graphql/static-1.85",
  "persist-promise": "/persist-promise/static-1.3895",
  "reporting-client-types": "/reporting-client-types/static-1.2617",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.89",
  "growth-payments-core": "/growth-payments-core/static-1.25951",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5071",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1323",
  "quartz-routing": "/quartz-routing/static-1.717",
  "hs-story-utils": "/hs-story-utils/static-1.9620",
  "react-flip-move": "/react-flip-move/static-1.74",
  "nested-table": "/nested-table/static-1.431",
  "timezone-utils": "/timezone-utils/static-2.5438",
  "seat-types-lib": "/seat-types-lib/static-1.447",
  "react-create-root-preference": "/react-create-root-preference/static-1.48",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4567",
  "floating-ui": "/floating-ui/static-1.60",
  "react-aria": "/react-aria/static-1.69",
  "tanstack-table": "/tanstack-table/static-1.58",
  "dispatcher": "/dispatcher/static-1.140",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.856",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.553",
  "module-federation": "/module-federation/static-1.29",
  "quartz-test": "/quartz-test/static-1.962",
  "quartz-tracking": "/quartz-tracking/static-1.666",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.262",
  "chirp-fetch": "/chirp-fetch/static-1.2081",
  "merchandise-lib": "/merchandise-lib/static-1.269",
  "purchase-motions-components": "/purchase-motions-components/static-1.6197",
  "salesImages": "/salesImages/static-1.529",
  "ts-schema": "/ts-schema/static-1.4214",
  "bender-build-tools": "/bender-build-tools/static-1.3316",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3116",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1392",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hs-resources": "/hs-resources/static-1.373",
  "pulse": "/pulse/static-1.810",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3931",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4272",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.207",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3825",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18983",
  "growth-data-modal": "/growth-data-modal/static-1.5741",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3255",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2484",
  "navigation-components": "/navigation-components/static-1.18556",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5173",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1025",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10456",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7837",
  "ui-universal-auth": "/ui-universal-auth/static-1.9208",
  "user-context": "/user-context/static-1.5305",
  "base-ui": "/base-ui/static-1.17",
  "react-day-picker": "/react-day-picker/static-1.6",
  "tanstack-virtual": "/tanstack-virtual/static-1.33",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10429",
  "magpie-lib": "/magpie-lib/static-1.5687",
  "navigation-messaging": "/navigation-messaging/static-1.7883",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "chatspot-core": "/chatspot-core/static-1.22293",
  "copilot-toolkit": "/copilot-toolkit/static-1.11631",
  "cms-field-types": "/cms-field-types/static-1.5009",
  "content-icons-ui": "/content-icons-ui/static-1.2282",
  "integrations-lib": "/integrations-lib/static-1.16767",
  "calling-global-api": "/calling-global-api/static-1.65166",
  "calling-internal-common": "/calling-internal-common/static-1.31508",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66548",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58842",
  "commerce-products-lib": "/commerce-products-lib/static-1.10273",
  "crm-links": "/crm-links/static-1.6509",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9758",
  "file-manager-components": "/file-manager-components/static-1.24190",
  "formula-editor": "/formula-editor/static-1.14594",
  "google-libphonenumber": "/google-libphonenumber/static-1.41",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4350",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.825",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49381",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4100",
  "property-value-citations": "/property-value-citations/static-1.2854",
  "smart-property-lib": "/smart-property-lib/static-1.8081",
  "tiered-pricing": "/tiered-pricing/static-1.1756",
  "topics-actions-lib": "/topics-actions-lib/static-1.346",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9270",
  "zustand": "/zustand/static-1.79",
  "final-form": "/final-form/static-1.73",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.20160",
  "tinymce-themes": "/tinymce-themes/static-1.56856",
  "data-token-picker": "/data-token-picker/static-1.16740",
  "hub-http-contrib": "/hub-http-contrib/static-1.3235",
  "interframe": "/interframe/static-3.4949",
  "tinymce-data": "/tinymce-data/static-1.40971",
  "tinymce-plugins": "/tinymce-plugins/static-1.58000",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5406",
  "onboarding-scopes": "/onboarding-scopes/static-1.6653",
  "ui-addon-opt": "/ui-addon-opt/static-4.8555",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4847",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.530",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.368",
  "purchase-motions-api": "/purchase-motions-api/static-1.6200",
  "event-emitter": "/event-emitter/static-1.1144",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.313",
  "fast-json-patch": "/fast-json-patch/static-1.66",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2299",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2512",
  "user-context-client": "/user-context-client/static-1.4745",
  "idb-keyval": "/idb-keyval/static-1.47",
  "magpie-types": "/magpie-types/static-1.5147",
  "nest": "/nest/static-1.430",
  "reactive-lib": "/reactive-lib/static-1.916",
  "simple-logging-lib": "/simple-logging-lib/static-1.3243",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1004",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18101",
  "markdown-it": "/markdown-it/static-1.6",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1408",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14182",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5801",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7972",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10559",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.722",
  "calling-error-reporting": "/calling-error-reporting/static-1.31515",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11232",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6734",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1700",
  "customer-data-tracking": "/customer-data-tracking/static-1.7078",
  "commerce-permissions": "/commerce-permissions/static-1.970",
  "products-iframe-lib": "/products-iframe-lib/static-1.8391",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10813",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9848",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "immerable": "/immerable/static-1.4341",
  "video-components-external": "/video-components-external/static-1.11907",
  "video-data-lib": "/video-data-lib/static-1.35565",
  "bark-lib": "/bark-lib/static-1.16686",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.98",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6081",
  "react-codemirror": "/react-codemirror/static-1.10832",
  "data-agent-kit": "/data-agent-kit/static-1.497",
  "feedback-loader": "/feedback-loader/static-1.29650",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10514",
  "fsm": "/fsm/static-1.3926",
  "policy-lib": "/policy-lib/static-1.6981",
  "react-colorpicker": "/react-colorpicker/static-2.10404",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10577",
  "FileManagerLib": "/FileManagerLib/static-1.39830",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9184",
  "FileManagerCore": "/FileManagerCore/static-1.39689",
  "content-assistance-lib": "/content-assistance-lib/static-1.8045",
  "layout-dnd-components": "/layout-dnd-components/static-1.12811",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11786",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10079",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15998",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15342",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7800",
  "breeze-engine-core": "/breeze-engine-core/static-1.686",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.82",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3205",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.245",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.752",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.814",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.918",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.260",
  "slack-ui-library": "/slack-ui-library/static-1.10592",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36477",
  "sales-views-client-types": "/sales-views-client-types/static-1.4451",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3718",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12940",
  "content-media-compositions": "/content-media-compositions/static-2.16947",
  "media-bridge-lib": "/media-bridge-lib/static-1.19258",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16137",
  "browser-eslint": "/browser-eslint/static-2.57",
  "trellis-story-utils": "/trellis-story-utils/static-1.4701",
  "storybook-react": "/storybook-react/static-1.36",
  "audio-components": "/audio-components/static-1.6199",
  "FileManagerImages": "/FileManagerImages/static-1.37341",
  "video-components": "/video-components/static-1.13909",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.57",
  "urlinator": "/urlinator/static-1.4726",
  "video-embed": "/video-embed/static-1.36399",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8900",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29103",
  "ContentData": "/ContentData/static-1.69006",
  "layout-data-lib": "/layout-data-lib/static-1.10111",
  "social-insights-client-types": "/social-insights-client-types/static-1.22581",
  "outpost": "/outpost/static-1.4360",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6775",
  "advanced-menus-core": "/advanced-menus-core/static-1.15440",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12334",
  "ExportDialog": "/ExportDialog/static-6.10574",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34584",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15439",
  "simple-menus-lib": "/simple-menus-lib/static-1.16956"
}
};
